/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { message } from "antd";
import { fetchAllUsers } from "../../services/userService";
import {fetchNewsWithAuthorById} from "../../services/newsService";
import { BASE_URL_IMAGE, BASE_URL } from "../../config/api";
 
const EditNews = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [status, setStatus] = useState();
  const [newsData, setNewsData] = useState({});
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [previewThumbnail, setPreviewThumbnail] = useState("");
  const [previewBanner, setPreviewBanner] = useState("");

  // Add author dropdown state
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [authors, setAuthors] = useState([]);

  // Fetch authors on component mount
  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const users = await fetchAllUsers();
        const mapped = users.map(user => ({
          userid: user.user_id,
          username: user.user_name,
          user_email: user.user_email
        }));
        setAuthors(mapped);
      } catch (err) {
        console.error("Failed to fetch authors:", err);
      }
    };
    fetchAuthors();
  }, []);

  // Filter authors based on search term
  const filteredAuthors = authors.filter(author =>
    author.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
    author.user_email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const categoryOptions = [
    { value: "health", label: "Health Care" },
    { value: "child", label: "Child" },
    { value: "safety", label: "Safety" },
  ];

  const subCategoryOptions = [
    { value: "healthcare", label: "Health Care" },
    { value: "corona", label: "Corona Virus" },
  ];

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  useEffect(() => {
  const fetchData = async () => {
    try {
      // 1. First fetch the news data
      // const newsResponse = await ;
      const newsData = await fetchNewsWithAuthorById(id);
      setNewsData(newsData);
      
      // Set basic fields
      setStatus(newsData.news_status);
      setDescription(newsData.news_description || "");
      setTitle(newsData.news_title || "");
      setRedirectUrl(newsData.news_redirecturl || "");

      // Set category if it exists in the news data
      if (newsData.news_category) {
        const foundCategory = categoryOptions.find(
          option => option.label.toLowerCase() === newsData.news_category.toLowerCase()
        );
        if (foundCategory) {
          setSelectedCategory(foundCategory);
        }
      }

      // 2. Then fetch authors
      const users = await fetchAllUsers();
      const mappedAuthors = users.map(user => ({
        userid: user.user_id,
        username: user.user_name,
        user_email: user.user_email
      }));
      setAuthors(mappedAuthors);

      // 3. Now find and set the selected author
      const currentAuthor = mappedAuthors.find(a => a.userid == newsData.news_author_id);
      if (currentAuthor) {
        setSelectedAuthor(currentAuthor);
      }

      // Set image previews
      if (newsData.news_thumbnail) {
        setPreviewThumbnail(`${BASE_URL_IMAGE}/uploads/newsImages/${newsData.news_thumbnail}`);
      }
      if (newsData.news_banner) {
        setPreviewBanner(`${BASE_URL_IMAGE}/uploads/newsImages/${newsData.news_banner}`);
      }

    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  fetchData();
}, [id]);

  const handleFileChange = (setter, previewSetter) => (e) => {
    const file = e.target.files[0];
    if (file) {
      setter(file);
      previewSetter(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    formData.append("title", title || "");
    formData.append("author_name", selectedAuthor?.userid || ""); // Use ID not name
    formData.append("category", selectedCategory?.label || "");
    formData.append("status", status);
    formData.append("description", description || "");
    formData.append("redirectURL", redirectUrl || "");
    
    if (thumbnailImage) formData.append("thumbnail", thumbnailImage);
    if (bannerImage) formData.append("banner", bannerImage);
    
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${BASE_URL}/news/updateNews/${id}`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (response.ok) {
        message.success("News updated successfully!");
        navigate("/list-news");
      } else {
        message.error("Update failed: " + (result.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error submitting update:", error);
      message.error("Something went wrong!");
    }
  };
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar id="menu-item11" id1="menu-items11" activeClassName="edit-blog" />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="#">News</Link></li>
                  <li className="breadcrumb-item"><FeatherIcon icon="chevron-right" /></li>
                  <li className="breadcrumb-item active">Edit News</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>News Details</h4>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>News Title</label>
                          <input className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Author <span className="login-danger">*</span></label>
                          <div className="dropdown">
                            <div className="form-control d-flex align-items-center justify-content-between"
                              style={{ cursor: "pointer", padding: "0.375rem 0.75rem" }}
                              onClick={() => setIsOpen(!isOpen)}
                            >
                              {selectedAuthor ? (
                                <span>{selectedAuthor.username} - {selectedAuthor.user_email}</span>
                              ) : (
                                <span className="text-muted">Select an author</span>
                              )}
                              <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                            </div>

                            {isOpen && (
                              <div className="dropdown-menu show w-100" style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6" }}>
                                <div className="px-2 py-1 sticky-top bg-white">
                                  <input type="text" className="form-control form-control-sm mb-2" placeholder="Search author..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    autoFocus
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>
                                {filteredAuthors.length > 0 ? (
                                  filteredAuthors.map((author) => (
                                    <button key={author.userid} type="button"
                                      className={`dropdown-item ${selectedAuthor?.userid === author.userid ? 'active' : ''}`}
                                      onClick={() => {
                                        setSelectedAuthor(author);
                                        setIsOpen(false);
                                        setSearchTerm("");
                                      }}
                                    >
                                      {author.username} - {author.user_email}
                                    </button>
                                  ))
                                ) : (
                                  <div className="dropdown-item text-muted">No matching author found</div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Redirect URL</label>
                          <input className="form-control" value={redirectUrl} onChange={(e) => setRedirectUrl(e.target.value)} />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group local-forms">
                          <label>Category</label>
                          <Select options={categoryOptions} value={selectedCategory} onChange={setSelectedCategory} />
                        </div>
                      </div>

                      
                     

                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group select-gender">
                          <label className="gen-label">Status <span className="login-danger">*</span></label>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input 
                                type="radio" 
                                name="status" 
                                value="1" 
                                checked={status === 1}
                                onChange={(e) => setStatus(Number(e.target.value))} 
                                className="form-check-input" 
                              /> Active
                            </label>
                          </div>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input 
                                type="radio" 
                                name="status" 
                                value="0" 
                                checked={status === 0}
                                onChange={(e) => setStatus(Number(e.target.value))} 
                                className="form-check-input" 
                              /> Inactive
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-3">
                        <TextEditor value={description} onChange={setDescription} />
                      </div>

                      <div className="row mt-4">
                        {/* Thumbnail Image */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="thumbnail" className="upload mb-2">
                                Thumbnail Image<span className="login-danger">*</span>
                              </label>
                              {previewThumbnail && (
                                <img 
                                  src={previewThumbnail} 
                                  alt="Thumbnail Preview" 
                                  style={{maxWidth: '100%', maxHeight: '200px', marginBottom: '10px'}} 
                                />
                              )}
                              <input 
                                type="file" 
                                accept="image/*" 
                                id="thumbnail"
                                onChange={handleFileChange(setThumbnailImage, setPreviewThumbnail)}
                                className="form-control"
                              />
                              {thumbnailImage && <small className="text-muted ">New Selected Thumbnail: {thumbnailImage.name}</small>}
                            </div>
                          </div>
                        </div>

                        {/* Banner Image */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="banner" className="upload mb-2">
                                Banner Image<span className="login-danger">*</span>
                              </label>
                              {previewBanner && (
                                <img 
                                  src={previewBanner} 
                                  alt="Banner Preview" 
                                  style={{maxWidth: '100%', maxHeight: '200px', marginBottom: '10px'}} 
                                />
                              )}
                              <input 
                                type="file" 
                                accept="image/*" 
                                id="banner"
                                onChange={handleFileChange(setBannerImage, setPreviewBanner)}
                                className="form-control"
                              />
                              {bannerImage && <small className="text-muted mt-1">New Selected Banner: {bannerImage.name}</small>}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 mt-4 text-end">
                        <button type="submit" className="btn btn-primary me-2">Update News</button>
                        <Link to="/list-news" className="btn btn-secondary">Cancel</Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default EditNews;